import { render, staticRenderFns } from "./DpoPayment.vue?vue&type=template&id=062f4699&scoped=true&"
import script from "./DpoPayment.vue?vue&type=script&lang=js&"
export * from "./DpoPayment.vue?vue&type=script&lang=js&"
import style0 from "./DpoPayment.vue?vue&type=style&index=0&id=062f4699&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f4699",
  null
  
)

export default component.exports